/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Einverstaendnisevaluation1Inputs */

const de__field_einverstaendnisevaluation1 = /** @type {(inputs: _Field_Einverstaendnisevaluation1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverständnis Evaluation`)
};

/**

* @param {_Field_Einverstaendnisevaluation1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_einverstaendnisevaluation1 = /** @type {((inputs?: _Field_Einverstaendnisevaluation1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Einverstaendnisevaluation1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_einverstaendnisevaluation1(inputs)
});
export { _field_einverstaendnisevaluation1 as "_field_einverstaendnisEvaluation" }